
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__fuel","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.41 4.59l-3.53-3.54-.71.71 2.32 2.31A2 2 0 1014 7.72V13a1 1 0 01-1 1 1 1 0 01-1-1V9a1 1 0 00-1-1h-1V3a2 2 0 00-2-2H4a2 2 0 00-2 2v12h8V9h.8a.2.2 0 01.2.2V13a2 2 0 002 2 2 2 0 002-2V6a2 2 0 00-.59-1.41zM8.75 5.75a1 1 0 01-1 1h-3.5a1 1 0 01-1-1v-2.5a1 1 0 011-1h3.5a1 1 0 011 1zM13 7a1 1 0 111-1 1 1 0 01-1 1z"}})])
          )
        }
      }
    